<template>
  <div>
    <v-layout class="mt-3">
      <v-flex xs4>
        <div>
          <v-menu offset-y>
            <template #activator="{ on }">
              <v-btn color="gray" outline v-on="on">
                {{ filter.job }}
                <i
                  class="fa fa-sort-desc ml-2"
                  style="font-size: 16px; margin-bottom: 6px"
                  aria-hidden="true"
                />
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in typeOptions"
                :key="index"
                @click="onChangeJob(item)"
              >
                <v-list-tile-title>{{ item }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </v-flex>
      <v-flex xs8 class="text-xs-right">
        <v-btn outline color="primary" :loading="loading" @click="onAddEmployee">
          <v-icon>add</v-icon>
          <span>เพิ่มรหัสพนักงาน</span>
        </v-btn>
        <v-btn color="primary" @click="showSearch">
          <v-icon>search</v-icon> {{ $t('advanced search') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      v-model="selected"
      :loading="loading"
      :headers="headers"
      :items="data"
      :pagination.sync="pagination"
      item-key="name"
      class="elevation-1 mt-3"
    >
      <!-- hide-actions -->
      <template #items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="props.item.first_name">
            {{ props.item.first_name }} {{ props.item.last_name }}
          </td>
          <td v-else>-</td>

          <td>{{ props.item.employeeid || '-' }}</td>
          <td>{{ props.item.job || '-' }}</td>
          <td>{{ props.item.phoneno || '-' }}</td>
          <td>{{ props.item.department || '-' }}</td>
          <td>{{ props.item.location || '-' }}</td>
          <td>{{ props.item.branch || '-' }}</td>
          <td>
            <v-btn
              :disabled="!['PC', 'Sales'].includes(props.item.job)"
              icon
              ripple
              outline
              color="primary"
              class="mr-1"
              @click="handleEdit(props.item)"
            >
              <em class="fa fa-pencil-alt middle" />
            </v-btn>

            <v-btn
              depressed
              color="primary"
              :disabled="!props.item.first_name"
              @click="onUnlinkAccount(props.item)"
            >
              <span style="font-size: 13px">ยกเลิกการผูกบัญชี</span>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="searchDialog" persistent width="500px">
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="searchDialog = false"> <v-icon>close</v-icon></v-btn>
        </div>
        <div class="px-3 pb-4">
          <v-layout row wrap>
            <v-flex xs12 class="form-control">
              <div>ชื่อพนักงาน</div>
              <input v-model="filter.name" type="text" />
            </v-flex>
            <v-flex xs12 class="form-control">
              <div>เบอร์โทรศัพท์</div>
              <input v-model="filter.phoneno" type="text"
            /></v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>เขต</div>
              <multiselect
                v-model="filter.department"
                :options="departmentOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                :max-height="200"
                open-direction="top"
                @input="
                  filter.location = ''
                  filter.branch = ''
                "
              ></multiselect>
            </v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>ห้าง</div>
              <multiselect
                v-model="filter.location"
                :options="locationOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                :max-height="150"
                open-direction="top"
                @input="filter.branch = ''"
              ></multiselect>
            </v-flex>
            <v-flex xs12 class="form-control pb-2">
              <div>สาขา</div>
              <multiselect
                v-model="filter.branch"
                :options="branchOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                open-direction="top"
                :max-height="250"
              ></multiselect>
            </v-flex>
          </v-layout>
          <div class="text-xs-center px-5">
            <v-btn
              :loading="loading"
              color="primary"
              depressed
              style="width: 150px"
              @click="onSearch"
              >{{ $t('Search') }}</v-btn
            >
            <v-btn outline color="grey" style="width: 150px" @click="clearSearch">{{
              $t('Clear Search')
            }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="employeeManamentDialog" persistent width="400px">
      <v-card class="pa-3">
        <div class="primary--text headline pb-3">เพิ่มรหัสพนักงาน</div>
        <v-layout wrap>
          <v-flex xs12 class="form-control">
            <div>รหัสพนักงาน</div>
            <input v-model="input.employeeId" type="number" />
          </v-flex>
          <v-flex class="text-xs-center mt-3">
            <div>
              <v-btn outline color="grey" @click="onCloseAddEmployee">{{ $t('cancel') }}</v-btn>
              <v-btn depressed color="primary" :loading="saveloading" @click="saveEmployee">{{
                $t('Save')
              }}</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditDialog" width="500px" persistent>
      <v-card class="pa-2">
        <div class="text-xs-right">
          <v-btn icon @click="handleCloseEdit"> <v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2">
          <v-layout wrap>
            <v-flex xs12 class="form-control pb-2">
              <div>เขต</div>
              <multiselect
                v-model="input.department"
                :options="departmentOptions"
                :allow-empty="false"
                :searchable="true"
                select-label
                deselect-label
                :max-height="input.job && input.job === 'PC' ? 200 : 80"
                open-direction="bottom"
                @input="
                  input.location = ''
                  input.branch = ''
                "
              ></multiselect>
            </v-flex>

            <template v-if="['PC'].includes(input.job)">
              <v-flex xs12 class="form-control pb-2">
                <div>ห้าง</div>
                <!-- <input v-model="input.location" type="text" /> -->
                <multiselect
                  v-model="input.location"
                  :options="locationInputOptions"
                  :allow-empty="false"
                  :searchable="true"
                  select-label
                  deselect-label
                  :max-height="150"
                  open-direction="bottom"
                  @input="input.branch = ''"
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="form-control pb-2">
                <div>สาขา</div>
                <multiselect
                  v-model="input.branch"
                  :options="branchInputOptions"
                  :allow-empty="false"
                  :searchable="true"
                  select-label
                  deselect-label
                  :max-height="150"
                  open-direction="top"
                ></multiselect>
              </v-flex>
            </template>

            <v-flex class="text-xs-center mt-3">
              <div>
                <v-btn outline color="grey" @click="handleCloseEdit">{{ $t('cancel') }}</v-btn>
                <v-btn
                  depressed
                  color="primary"
                  :loading="saveloading"
                  @click="handleSaveEditData"
                  >{{ $t('Save') }}</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import KingkitchenApi from '@/api/kingkitchen'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      search: '',
      detailToggle: false,
      pagination: {
        rowsPerPage: 25
      },
      selected: [],
      headers: [
        { text: 'ชื่อ', value: 'name', sortable: false },
        { text: 'รหัสพนักงาน', value: 'employeeid', sortable: false },
        { text: 'ตำแหน่ง', value: 'job', sortable: false },
        { text: 'เบอร์ติดต่อ', value: 'phoneno', sortable: false },
        { text: 'เขต', value: 'department', sortable: false },
        { text: 'ร้าน', value: 'location', sortable: false },
        { text: 'สาขา', value: 'branch', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      data: [],
      filter: {
        name: '',
        job: 'ทั้งหมด',
        phoneno: '',
        department: '',
        location: '',
        branch: ''
      },
      searchDialog: false,
      loading: false,
      employeeManamentDialog: false,
      input: {
        employeeId: '',
        job: '',
        department: '',
        location: '',
        branch: ''
      },
      saveloading: false,
      showEditDialog: false,
      editData: null,
      masterData: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    typeOptions() {
      // var jobs = [...new Set(this.data.map((el) => el.job))].filter((el) => el)
      return ['ทั้งหมด', `Sales`, `PC`, 'ช่าง', 'ช่าง (SCG)']
    },
    departmentOptions() {
      let tempOptions = []
      if (this.masterData) {
        this.masterData.forEach((item) => {
          if (![...tempOptions].includes(item.department)) {
            tempOptions.push(item.department)
          }
        })
      }
      return tempOptions
    },
    locationOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.filter.department) {
          let filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.filter.department
          })

          filteredByDepartment.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        }
      }
      return tempOptions
    },
    branchOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.filter.department) {
          let tempFilter = []
          const filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.filter.department
          })

          tempFilter = filteredByDepartment

          if (this.filter.location) {
            tempFilter = filteredByDepartment.filter((el) => {
              return el.location === this.filter.location
            })
          }

          tempFilter.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        }
      }
      return tempOptions
    },
    locationInputOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.input.department) {
          let filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.input.department
          })

          filteredByDepartment.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        }
      }

      return tempOptions
    },
    branchInputOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.input.department) {
          let tempFilter = []
          const filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.input.department
          })

          tempFilter = filteredByDepartment

          if (this.input.location) {
            tempFilter = filteredByDepartment.filter((el) => {
              return el.location === this.input.location
            })
          }

          tempFilter.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        }
      }

      return tempOptions
    }
  },
  mounted() {
    this.getData()
    this.getMasterData()
  },
  methods: {
    onChangeJob(item) {
      this.filter.job = item
      this.getData()
    },
    onSearch() {
      this.searchDialog = false
      this.getData()
    },
    showSearch() {
      this.searchDialog = true
    },
    clearSearch() {
      this.filter = {
        name: '',
        phoneno: '',
        department: '',
        location: '',
        branch: ''
      }
      this.getData()
      this.searchDialog = false
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.filter
      }
      if (this.filter.job === 'ทั้งหมด') {
        data.job = ''
      }
      api.kingkitchengetemployee(data, (err, response) => {
        this.data = response.data
        this.loading = false
      })
    },
    closeDetailToggle() {
      this.detailToggle = false
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    saveEmployee() {
      if (this.input.employeeId == '') {
        this.$swal.fire({
          text: 'กรุณากรอกรหัสพนักงาน'
        })
      } else {
        let data = {
          employeeid: this.input.employeeId,
          pageid: this.selectedBot.pageid
        }

        this.saveloading = true
        api.kingkitchenAddEmployeeId(data, (err, response) => {
          this.saveloading = false
          if (response && response.responsecode == 200) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.onCloseAddEmployee()
            this.getData()
          }
        })
      }
    },
    onAddEmployee() {
      this.employeeManamentDialog = true
    },
    onCloseAddEmployee() {
      this.input = {
        employeeId: ''
      }
      this.employeeManamentDialog = false
    },
    onUnlinkAccount(item) {
      let vm = this
      vm.$swal
        .fire({
          title: 'ยืนยันการยกเลิกการผูกบัญชี ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let empId = item.employeeid
            let data = {
              employeeid: empId,
              pageid: vm.selectedBot.pageid
            }
            api.kingkitchenUnlinkMember(data, (err, response) => {
              if (err) {
                console.error(err)
                return
              }

              if (response && response.responsecode == 200) {
                vm.$swal.fire({
                  type: 'success',
                  title: this.$t('Success')
                })
                vm.getData()
              }
            })
          }
        })
    },
    handleEdit(item) {
      const vm = this
      vm.input.employeeId = item.employeeid
      vm.input.job = item.job
      vm.input.department = item.department
      vm.input.location = item.location
      vm.input.branch = item.branch
      vm.showEditDialog = true
    },
    handleCloseEdit() {
      const vm = this
      vm.input = {
        employeeId: '',
        job: '',
        department: '',
        location: '',
        branch: ''
      }
      vm.showEditDialog = false
    },
    async handleSaveEditData() {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          employeeid: vm.input.employeeId,
          department: vm.input.department
        }

        if (vm.input.job === 'PC') {
          Object.assign(data, {
            location: vm.input.location,
            branch: vm.input.branch
          })
        }

        vm.saveloading = true
        const response = await KingkitchenApi.putEditEmployee({ data: data })
        vm.saveloading = false
        if (response && response.status === 200) {
          vm.getData()
          vm.handleCloseEdit()
        }
      } catch (error) {
        vm.saveloading = false
        console.error(error)
      }
    },
    async getMasterData() {
      const vm = this
      try {
        // const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: 500,
          offset: 0,
          department: '',
          location: '',
          branch: ''
        }

        const response = await KingkitchenApi.getKingkitchenBranch({
          config: {
            params: data
          }
        })

        if (response && response.status === 200) {
          vm.masterData = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/member/Employee.vue